module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "girl3"
    }
  }, [_c('path', {
    attrs: {
      "id": "girl3_right_hand",
      "fill": "#E2B56C",
      "d": "M5673.63 346.18c-.35 1.63-1.16 2.44-2.67 4.16-1.75 2-2.4 6.08-4.54 9.23.26.86 3.04-.15 3.82-1.43.8-1.28 1.4-2.32 1.64-2.64.25-.3.68-.2.75.15.06.35-2 12.34-1.83 12.98.15.63 1.67.94 2.05.38.4-.54 2.25-9.98 2.43-10.2.18-.24.5-.06.6.1.12.16-2.15 10.2-2 10.6.15.43 1.74.66 1.97.38.23-.28 2.3-10.3 2.53-10.5.2-.2.55-.12.66.1.1.24-2.24 9.84-2.08 10.3.17.47 1.7.76 1.9.36.24-.4 2.5-10.06 2.68-10.18.18-.1.37-.06.5.1.1.15-1.2 7.44-1.05 7.88.16.45 1.3.76 1.56.3.27-.46 3.02-18.32 3.24-19.3.74-3.26-.9-7.12-4.65-7.73-3.74-.6-6.8 1.46-7.52 4.98z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_arm_bottom",
      "fill": "#E2B56C",
      "d": "M5684.5 320.43c3.4.53 5.72 3.64 5.18 6.96l-3.43 21.15c-.54 3.32-3.73 5.58-7.13 5.06-3.4-.52-5.73-3.63-5.2-6.95l3.45-21.16c.54-3.33 3.73-5.6 7.13-5.07z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_arm_top",
      "fill": "#E2B56C",
      "d": "M5687.88 296.57c3.4.53 5.72 3.65 5.2 6.97l-3.84 23.56c-.54 3.32-3.73 5.58-7.13 5.06-3.4-.53-5.7-3.65-5.17-6.97l3.82-23.57c.54-3.32 3.73-5.58 7.13-5.06z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_leg_bottom",
      "fill": "#E2B56C",
      "d": "M5695.15 389.58c3.45 0 6.24 2.8 6.24 6.24v29.3h-12.48v-29.3c0-3.44 2.8-6.24 6.23-6.24z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl3_right_leg_top",
      "width": "12.47",
      "height": "55.5",
      "x": "5688.92",
      "y": "346.25",
      "fill": "#E2B56C",
      "rx": "6.23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_shoe_6",
      "fill": "#91713D",
      "d": "M5693.7 424.03c-.7-1.13-4.83-1.28-5.33.43-.2.66 0 2.5 0 3.76 0 1.26-.3 6.03-2.57 8.15-2.27 2.13-6.5 3.63-7.85 4.12.34 1.03 3.36 1.5 5.34 1.95 11.25-3.48 10.9-17.62 10.4-18.42z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_shoe_5",
      "fill": "#A98448",
      "d": "M5693.5 425.13h7.96c-.06 2.02.27 19.17-.06 22.5h-27.8c-.18-1.5-1.1-5.85 5.38-7.67.67.5 1.4 1.04 3.73 1.82 9.97-2.46 10.77-14.08 10.8-16.65z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_shoe_4",
      "fill": "#FBD79E",
      "d": "M5681.6 445.9l20-.02c-.02.26-.02.96 0 2.1-18.93.03-28.6.03-29.04.03-.15-1.2-.76-5.34 4.32-7.25 1.4-.4 4.53 2.15 4.72 5.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_shoe_3",
      "fill": "#FBD79E",
      "d": "M5686.7 440.37c-.46-.72-3.36-1.94-4.42-2.1-.44-.05-.9.3-.84.75 1.34.25 3.88 1.47 4.32 1.95.44.5 1.38.12.93-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_shoe_2",
      "fill": "#FBD79E",
      "d": "M5690.18 437.94c.45.72-.5 1.08-.93.6-.44-.5-2.98-1.7-4.32-1.96-.06-.44.4-.8.84-.74 1.06.15 3.96 1.37 4.4 2.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_shoe_1",
      "fill": "#FBD79E",
      "d": "M5691.88 435c.45.74-.5 1.1-.94.62-.44-.5-2.67-1.58-4-1.83-.06-.45.08-.94.53-.88 1.05.15 3.95 1.37 4.4 2.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_leg_bottom",
      "fill": "#E2B56C",
      "d": "M5715.1 389.58c3.45 0 6.24 2.8 6.24 6.24v29.3h-12.47v-29.3c0-3.44 2.8-6.24 6.24-6.24z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_leg_top",
      "fill": "#E2B56C",
      "d": "M5715.1 346.25c3.45 0 6.24 2.8 6.24 6.24v43.02c0 3.44-2.8 6.24-6.23 6.24-3.44 0-6.23-2.8-6.23-6.24V352.5c0-3.45 2.8-6.25 6.24-6.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_shoe_6",
      "fill": "#91713D",
      "d": "M5713.65 424.03c-.7-1.13-4.83-1.28-5.33.43-.2.66 0 2.5 0 3.76 0 1.26-.3 6.03-2.57 8.15-2.26 2.13-6.5 3.63-7.85 4.12.34 1.03 3.36 1.5 5.34 1.95 11.26-3.48 10.92-17.62 10.4-18.42z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_eft_shoe_5",
      "fill": "#A98448",
      "d": "M5713.72 425.13h7.7c-.07 2.04.26 19.17-.07 22.5h-27.8c-.17-1.5-1.1-5.85 5.38-7.67.67.5 1.4 1.04 3.73 1.82 11.1-2.42 9.95-14.86 11.06-16.65z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_shoe_4",
      "fill": "#FBD79E",
      "d": "M5701.56 445.9l20-.02c-.03.26-.03.96 0 2.1-18.94.03-28.62.03-29.05.03-.14-1.2-.74-5.34 4.33-7.25 1.4-.4 4.53 2.15 4.73 5.15z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_shoe_3",
      "fill": "#FBD79E",
      "d": "M5706.64 440.37c-.45-.72-3.35-1.94-4.4-2.1-.45-.05-.9.3-.85.75 1.33.25 3.87 1.47 4.3 1.95.45.5 1.4.12.94-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_shoe_2",
      "fill": "#FBD79E",
      "d": "M5710.13 437.94c-.45-.73-3.35-1.95-4.4-2.1-.45-.06-.9.3-.84.74 1.32.25 3.86 1.47 4.3 1.96.44.48 1.38.12.93-.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_shoe_1",
      "fill": "#FBD79E",
      "d": "M5711.83 435c.45.74-.5 1.1-.93.62-.44-.5-2.68-1.58-4-1.83-.07-.45.08-.94.52-.88 1.06.15 3.96 1.37 4.4 2.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_dress",
      "fill": "#FBD79E",
      "d": "M5692.96 294.14c6.92-3.12 20.5-2.56 27.3 2.5 2.2 1.62 6.88 17.9-.74 30.05 8.98 5.84 14.04 21.17 15.2 45.98-6.16 2.16-16.54 3.25-31.13 3.25-14.6 0-25-1.1-31.14-3.25.36-22.22 5.65-37.54 15.88-46-2.2-1.7-7.4-7.12-6.67-14.6 1.04-10.9 8.6-16.72 11.3-17.94z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_bag_3",
      "fill": "#A98448",
      "d": "M5698.47 337.65c3-1.75 28.37-3.7 32.13 0 3.75 3.7 10.93 21.05 3 27.98-7.9 6.93-26.4 8.32-34.6.9-8.18-7.42-3.54-27.14-.53-28.88z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_bag_2",
      "fill": "#BC9555",
      "d": "M5698.4 337.65c3-1.75 28.37-3.7 32.13 0 3.75 3.7 17.78 24.37-5.6 27.26-23.38 2.9-21.2-22.8-22.22-25.02-1-2.23-3.44-2.23-4.3-2.23z"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "girl3_bag_1",
      "fill": "#91713D",
      "points": "5685.42768 300.139673 5689.32978 296.108369 5701.6123 344.434571 5696.78083 344.434571"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_hand",
      "fill": "#E2B56C",
      "d": "M5716.84 346.46c-.08 1.67-.76 2.6-1.97 4.53-1.4 2.24-1.4 6.36-3 9.8.4.8 2.98-.62 3.54-2 .58-1.38 1.02-2.5 1.2-2.86.2-.34.64-.3.77.03.12.34 0 12.5.27 13.1.26.6 1.8.68 2.1.07.3-.6.6-10.22.75-10.47.13-.25.47-.12.6.02.15.13-.5 10.38-.27 10.77.2.4 1.82.38 2 .07.2-.3.63-10.54.8-10.77.2-.23.55-.2.7.02.12.2-.64 10.04-.4 10.47.22.44 1.77.5 1.93.07.16-.43.85-10.33 1-10.47.16-.13.36-.12.5.02.14.13 0 7.53.24 7.94.24.4 1.4.54 1.6.05.2-.5.04-18.57.1-19.57.2-3.33-2.03-6.9-5.82-6.92-3.8-.02-6.48 2.48-6.64 6.06z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_arm_bottom",
      "fill": "#E2B56C",
      "d": "M5723.1 319c3.43 0 6.22 2.78 6.22 6.23v21.12c0 3.44-2.8 6.23-6.23 6.23-3.46 0-6.25-2.8-6.25-6.23v-21.12c0-3.45 2.8-6.24 6.24-6.24z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl3_left_arm_top",
      "width": "12.47",
      "height": "36.03",
      "x": "5716.85",
      "y": "295.13",
      "fill": "#E2B56C",
      "rx": "6.23"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_neck",
      "fill": "#E2B56C",
      "d": "M5699.04 289.77c2.22-1.3 5.74-1.27 7.98 0-.08 2.37-.6 3.27 1.06 4.57-1.93 2.96-8.23 3.07-10.18 0 1.27-.88 1.4-2.85 1.14-4.57z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_face",
      "fill": "#E2B56C",
      "d": "M5701.93 246.94c17.34.07 20.85 12.55 20.7 21.08 8.43-.73 2.14 15.83-4.08 13 0 2.62-5.2 9.96-16.62 9.82-11.43-.13-18.28-9.26-17.43-20.7.86-11.44 2.94-23.26 17.43-23.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_mouth_bottom",
      "fill": "#BC9555",
      "fill-rule": "nonzero",
      "d": "M5697.9 285.46c.84.2 5.56.26 7.13-.05.84-.15-1.05 1.4-4.2 1.4-3.14 0-2.93-1.34-2.93-1.34z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_mouth_top",
      "fill": "#BC9555",
      "fill-rule": "nonzero",
      "d": "M5697.4 285.17c0-.67.52-1.23 3.25-1.23 1.9 0 4.93.92 6.45.5.32-.1.32.16-.1.32-1.94.66-3.83.66-6.72.66-1.88-.05-2.88-.25-2.88-.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_nose",
      "fill": "#BC9555",
      "d": "M5699.72 272.07c0-1 2.66-1.1 2.66 0s.86 6.84 0 7.86c-.85 1.02-3.37.68-3.76 0-.4-.68-.3-1.78.53-2.1.85-.3.57-4.75.57-5.76z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_eye_whites",
      "fill": "#FBD79E",
      "d": "M5705.88 273.04c1.4-3.78 7.65-4.36 8.6-1.08 0 4.42-7.58 4.8-8.6 1.08z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "girl3_left_pupil",
      "cx": "5709.52",
      "cy": "272.89",
      "fill": "#91713D",
      "rx": "2.15",
      "ry": "2.1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_eye_whites",
      "fill": "#FBD79E",
      "d": "M5696 273.04c-1.4-3.78-7.64-4.36-8.58-1.08 0 4.42 7.57 4.8 8.6 1.08z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "girl3_right_pupil",
      "cx": "5691.06",
      "cy": "272.89",
      "fill": "#91713D",
      "rx": "2.15",
      "ry": "2.1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_left_brow",
      "fill": "#BC9555",
      "d": "M5705.93 266.4c1.07-.58 6.73-.68 7.97 0 1.24.65.33 1.8-.53 1.54-.87-.26-6-.32-6.9 0-.93.3-1.62-1-.54-1.55z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_right_brow",
      "fill": "#BC9555",
      "d": "M5696 266.4c-1.07-.58-6.73-.68-7.97 0-1.24.65-.33 1.8.53 1.54.86-.26 6-.32 6.9 0 .93.3 1.62-1 .54-1.55z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl3_hair",
      "fill": "#BC9555",
      "d": "M5688.77 257.05c1.95 4.23 6.24 8.52 12.88 12.86l-.8-4.3 4.05 4.3v-5.6l3.45 5.6.63-4.3 3.46 4.3v-4.3l4.1 4.3v-4.3l3.06 6.07.7-3.76 3.53 6.43 1.3-5.58c1.34-6.7.46-12.3-2.64-16.78-4.65-6.72-12.68-8.47-20.58-7.84-7.9.64-17.74 6.98-19.07 15.5-.9 5.66-.35 9.68 1.63 12.04-.06-6.02 1.37-10.9 4.3-14.62z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8477a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_2/backgroundCharacters/girlThree.vue
// module id = 662
// module chunks = 1